import actions from './actions';

const initialState = {
  isSearching: false,
  isCreating: false,
  isUpdating: false,
};

export default function permissionReducer(state = initialState, action) {
  switch (action.type) {
    case actions.CREATE_USER:
    case actions.CREATE_ROLE:
      return {
        ...state,
        isCreating: true,
      };
    case actions.CREATE_USER_ENDED:
    case actions.CREATE_ROLE_ENDED:
      return {
        ...state,
        isCreating: false,
      };
    case actions.SEARCH_USERS:
    case actions.GET_ACCOUNT_FILTER_FORM_ROLES:
    case actions.GET_ACCOUNT_CREATION_FORM_ROLES:
    case actions.FIND_USER:
    case actions.SEARCH_ROLES:
    case actions.FIND_ROLE:
    case actions.GET_USER_ROLES:
    case actions.GET_PERMISSIONS:
      return {
        ...state,
        isSearching: true,
      };
    case actions.SEARCH_USERS_ENDED:
    case actions.GET_ACCOUNT_FILTER_FORM_ROLES_ENDED:
    case actions.GET_ACCOUNT_CREATION_FORM_ROLES_ENDED:
    case actions.FIND_USER_ENDED:
    case actions.SEARCH_ROLES_ENDED:
    case actions.FIND_ROLE_ENDED:
    case actions.GET_USER_ROLES_ENDED:
    case actions.GET_PERMISSIONS_ENDED:
      return {
        ...state,
        isSearching: false,
      };
    case actions.UPDATE_USER:
    case actions.UPDATE_USER_STATUS:
    case actions.UPDATE_USER_PROFILE:
    case actions.UPDATE_USER_PASSWORD:
    case actions.RESET_USER_PASSWORD:
    case actions.UPDATE_ROLE:
      return {
        ...state,
        isUpdating: true,
      };
    case actions.UPDATE_USER_ENDED:
    case actions.UPDATE_USER_STATUS_ENDED:
    case actions.UPDATE_USER_PROFILE_ENDED:
    case actions.UPDATE_USER_PASSWORD_ENDED:
    case actions.RESET_USER_PASSWORD_ENDED:
    case actions.UPDATE_ROLE_ENDED:
      return {
        ...state,
        isUpdating: false,
      };
    case actions.DELETE_ROLES:
      return {
        ...state,
        isDeleting: true,
      };
    case actions.DELETE_ROLES_ENDED:
      return {
        ...state,
        isDeleting: false,
      };
    default:
      return state;
  }
}
